import React, { useState } from 'react';
import { Box, CircularProgress, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iframe from 'react-iframe';
import ChatMessagesList from '../Chat/SubComponents/ChatMessagesList/ChatMessagesList';
import DocumentPreviewWithBoxes from '../DocumentBoxViewer/DocumentPreviewWithBoxes';
import NoDocumentsPdf from '../../assests/pdf/NoDocument.pdf';

export default function DocumentConversationSideTabs({
    documentUrl,
    documentId,
    documentTitle,
    messages = [],
    loading = false,
    refreshMessages,
    headerAction = null,
    initialTab = 'document',
    // OCR field boxes (optional): see DocumentBoxViewer / useFieldPositions.
    fieldPositions = null,
    visibleFields,
    activeField,
    fieldLabels,
    fieldOrder,
    onFieldClick,
    onBoxesShownChange,
}) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(initialTab);
    const previewUrl = documentUrl || NoDocumentsPdf;

    return (
        <div className="edit-modal-pdf-pane">
            <Tabs
                value={tab}
                onChange={(_, value) => setTab(value)}
                variant="fullWidth"
                className="edit-modal-side-tabs"
                sx={{
                    minHeight: 40,
                    '& .MuiTab-root': {
                        minHeight: 40,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: 13,
                    },
                }}
            >
                <Tab value="document" label={t('Document')} />
                <Tab
                    value="conversation"
                    label={
                        messages.length > 0
                            ? `${t('ClarificationConversation')} (${messages.length})`
                            : t('ClarificationConversation')
                    }
                />
            </Tabs>
            <div className="edit-modal-side-tab-body">
                {tab === 'document' ? (
                    <DocumentPreviewWithBoxes
                        url={documentUrl}
                        positions={fieldPositions}
                        visibleFields={visibleFields}
                        activeField={activeField}
                        fieldLabels={fieldLabels}
                        fieldOrder={fieldOrder}
                        onFieldClick={onFieldClick}
                        onBoxesShownChange={onBoxesShownChange}
                        renderFallback={() => (
                            <Iframe
                                key={documentUrl || 'no-document'}
                                url={`${previewUrl}#page=1&view=FitH`}
                                width="100%"
                                height="100%"
                                id={String(documentId || 'document-preview')}
                                position="relative"
                                title={documentTitle || 'document-preview'}
                                allowFullScreen
                            />
                        )}
                    />
                ) : (
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#fff' }}>
                        {headerAction && (
                            <Box
                                sx={{
                                    px: 1.5,
                                    py: 1,
                                    borderBottom: '1px solid #E5E7EB',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                    gap: 1,
                                    flexWrap: 'wrap',
                                }}
                            >
                                {headerAction}
                            </Box>
                        )}
                        {loading ? (
                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <CircularProgress size={28} />
                            </Box>
                        ) : messages.length > 0 ? (
                            <Box sx={{ flex: 1, minHeight: 0 }}>
                                <ChatMessagesList
                                    messages={messages}
                                    containerHeight="100%"
                                    highestPageLoaded={1}
                                    lowestPageLoaded={1}
                                    getAllForReceiver={false}
                                    refreshMessages={refreshMessages}
                                    enableSelectionActions={false}
                                    allowDeleteSelected={false}
                                    showParticipantNames
                                />
                            </Box>
                        ) : (
                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                                <span style={{ color: '#6B7280', fontSize: 13 }}>
                                    {t('NoClarificationConversation')}
                                </span>
                            </Box>
                        )}
                    </Box>
                )}
            </div>
        </div>
    );
}
